'use client'
/**
 * @fileoverview Global error boundary. Template sync retired; safe to edit.
 */

import React from 'react'

export const dynamic = 'force-dynamic'

function logError(error: Error & { digest?: string }) {
  if (typeof window === 'undefined') return
  console.error('[Next.js Global Error] Full error details:', {
    name: error.name,
    message: error instanceof Error ? error.message : String(error),
    stack: error.stack,
    digest: error.digest,
    ...Object.fromEntries(
      Object.entries(error).filter(([key]) => !['name', 'message', 'stack', 'digest'].includes(key))
    ),
  })
}

/** Inline minimal tree for prerender - no child component to avoid any useContext in the route. */
function minimalTree() {
  return React.createElement(
    'html',
    null,
    React.createElement('body', null,
      React.createElement('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: 'var(--background-default)',
          padding: '2rem',
        },
      }, 'Something went wrong.')
    )
  )
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  try {
    if (typeof window === 'undefined') {
      return minimalTree()
    }
    logError(error)
    const msg = (error instanceof Error ? error.message : String(error)) || 'An unexpected error occurred.'
    return React.createElement(
    'html',
    null,
    React.createElement(
      'body',
      null,
      React.createElement('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: 'var(--background-default)',
        },
      }, [
        React.createElement('h1', {
          key: 'h1',
          style: { fontSize: '2.25rem', fontWeight: 'bold', color: 'var(--foreground-default)', marginBottom: '1rem' },
        }, 'Something went wrong!'),
        React.createElement('p', {
          key: 'p',
          style: { color: 'var(--foreground-muted)', marginBottom: '2rem' },
        }, msg),
        React.createElement('button', {
          key: 'btn',
          onClick: () => reset(),
          style: {
            padding: '0.5rem 1rem',
            backgroundColor: 'var(--primary-default)',
            color: 'var(--background-default)',
            borderRadius: '0.375rem',
            border: 'none',
            cursor: 'pointer',
          },
        }, 'Try again'),
      ])
    )
  )
  } catch {
    return minimalTree()
  }
}
